import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export type DefaultQueryKey = "debug" | "role" | "keyfrom";

export default function useRouteQuery<kType extends string = DefaultQueryKey>() {
  const location = useLocation();
  return useMemo(() => {
    const queryList: any = new URLSearchParams(location.search).entries();
    const query = [...queryList].reduce((acc, [key, value]) => {
      acc[key as kType] = value;
      return acc;
    }, {} as Record<kType, string>);

    return query;
  }, [location.search]);
}
